// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@/services/firebase-init'
import App from './App'
import router from './router'
import VS2 from 'vue-script2'
import BootstrapVue from 'bootstrap-vue'
import Icon from 'vue-awesome/components/Icon'
import Spreadsheet from '@/components/Spreadsheet'
import store from '@/store'
import Vuelidate from 'vuelidate'
import { codemirror } from 'vue-codemirror'
import InputTag from 'vue-input-tag'
import { abilitiesPlugin } from '@casl/vue'
import { mapState } from 'vuex'
import PivotTable from '@/components/PivotTable'
import Vue2Filters from 'vue2-filters'
import VueDraggableResizable from 'vue-draggable-resizable'
import VueNumerals from 'vue-numerals'
import JsonEditor from '@/components/JsonEditor'
import TreeView from 'vue-json-tree-view'
import DataGrid from '@/components/DataGrid'
import Chart from '@/components/Chart'
import PivotGrid from '@/components/PivotGrid/PivotAll'
import alasqlJs from 'alasql'
const alasql = {
  install (v) {
    Vue.prototype.alasql = alasqlJs
  }
}


// import libs
import '@/libs'

import directives from '@/directives'
import utils from '@/helpers/utils'

// vendor components
import '@/components/_vendor/charts'

// helpers
import AuthStatusCheck from '@/helpers/auth-status-check'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VS2)
Vue.use(Vuelidate)
Vue.use(abilitiesPlugin)
Vue.use(Vue2Filters, 'filterBy')
Vue.use(VueNumerals, { locale: 'en-au' })
Vue.use(JsonEditor)
Vue.use(TreeView)
Vue.use(alasql)


// components registration
Vue.component('icon', Icon)
Vue.component('Spreadsheet', Spreadsheet)
Vue.component('input-tag', InputTag)
Vue.component('PivotTable', PivotTable)
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.component('codemirror', codemirror)
Vue.component('DataGrid', DataGrid)
Vue.component('Chart', Chart)
Vue.component('PivotGrid', PivotGrid)

// set utils to vue instance
for (let utilName in utils) {
  Vue.prototype['$' + utilName] = utils[utilName]
}

// set directives to vue instance
for (let directive in directives) {
  Vue.directive(directive, directives[directive])
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App,
    Icon,
    Spreadsheet,
    codemirror
  },
  template: '<App/>',
  computed: {
    ...mapState([
      'caslRules'
    ])
  },
  created () {
    this.$ability.update(this.caslRules)

    this.$store.watch(
      (state) => {
        return state.caslRules
      },
      (newRules) => {
        this.$ability.update(Object.values(newRules))
      }
    )

    new AuthStatusCheck(this.$store, this.$router)
  }
})



// WEBPACK FOOTER //
// ./src/main.js